<script setup>
import GarageEventScheduler from '@/components/garage/GarageEventScheduler.vue'
</script>
<template>
  <garage-event-scheduler />
</template>
